/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { CREATE_BOX } from "../graphql/createBox.mutation";
import { CREATE_ORDER } from "../graphql/createOrder.mutation";
import { StorageModule } from "@vlinder-web/storage-module-react";
import { CHECK_PAYMENT_FROM_FAC } from "../graphql/checkoutFAC.mutation";
import { GET_CURRENCY_EXCHANGE_RATE } from "../graphql/getCurrencyExchangeRate.query";
import { REGISTER_PAYMENT } from "../graphql/registerPayment.mutation";

const is = require("is_js");

const buildAllocations = (items: any[], totalAmount: number) => {
  if (!items || items.length === 0) return [];
  const eachAmount = parseFloat((totalAmount / items.length).toFixed(2));
  let sum = 0;
  const list = items.map((item, idx) => {
    const costumeValueId = item?.costumeValue?.id || item?.costumeValue;
    const isLast = idx === items.length - 1;
    const amount = isLast
      ? parseFloat((totalAmount - sum).toFixed(2))
      : eachAmount;
    sum += amount;
    return { costumeValueId, amount };
  });
  return list;
};

export interface ICreateBoxArgs {
  presentationID: string;
  sectionID: string;
  email: string;
  name: string;
  mode: string;
  price: any;
  currency: string;
  items: {
    costumeType: string;
    costumeFeature: string;
    costumeAttribute: string;
    costumeValue: string;
  }[];
}

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ICreateBoxTypeMethods extends IPluginMethodMap {
  createBox(args: any): Promise<any>;
}

export class CreateBoxService implements IAgentPlugin {
  readonly methods: ICreateBoxTypeMethods;

  constructor() {
    this.methods = {
      createBox: this.createBox.bind(this),
    };
  }

  async createBox(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    const storageService = StorageModule.getInstance();
    console.log("57print", args);
    let variables: any = {
      data: {
        presentation: args?.presentationID,
        section: args?.sectionID,
        items: args?.items,
        referal: args?.refId,
      },
    };
    if (args?.code) {
      variables = {
        ...variables,
        discountCode: args?.code,
      };
    }
    try {
      if (client) {
        const res = await client.mutate({
          mutation: CREATE_BOX,
          variables: variables,
          fetchPolicy: "no-cache",
        });
        const _res = await client.query({
          query: GET_CURRENCY_EXCHANGE_RATE,
          fetchPolicy: "network-only",
        });

        if (_res?.data?.getCurrencyExchangeRate) {
          storageService.set(
            "currencyExchangeLocal",
            _res?.data?.getCurrencyExchangeRate,
            "local"
          );
          storageService.set(
            "currencyExchangeSession",
            _res?.data?.getCurrencyExchangeRate,
            "session"
          );
        }
        console.log(res?.data?.createBox, is.existy(res?.data?.createBox));
        if (res?.data?.createBox && is.existy(res?.data?.createBox)) {
          console.log("hii");
          if (args?.mode === "online") {
            if (
              storageService.get("currencyExchangeLocal", "local")?.provider ===
              "FAC"
            ) {
              const finalAllocations =
                args?.allocations && args.allocations.length > 0
                  ? args.allocations
                  : buildAllocations(args?.items, parseFloat(args?.amount));

              let variables: any = {
                data: {
                  cardDetail: {
                    cardExp: args?.expiry,
                    cardHolderName: args?.name,
                    cardPan: args?.number,
                    cvv: args?.cvc,
                  },
                  currency: args?.currency,
                  // tax: uuidv4(),
                  totalAmount: parseFloat(args?.amount),
                  payOrder: res?.data?.createBox?.payOrder?.id,
                  ...(finalAllocations &&
                    finalAllocations.length > 0 && {
                      allocations: finalAllocations,
                    }),
                },
              };
              if (args?.myEmail) {
                variables = {
                  ...variables,
                  data: {
                    ...variables?.data,
                    email: args?.myEmail,
                  },
                };
              }
              if (args?.phone) {
                variables = {
                  ...variables,
                  data: {
                    ...variables?.data,
                    phoneNumber: args?.event?.phone,
                  },
                };
              }
              console.log(variables);
              const resfac = await client.mutate({
                mutation: CHECK_PAYMENT_FROM_FAC,
                variables: variables,
                fetchPolicy: "no-cache",
              });

              if (is.existy(resfac?.data?.createCheckoutFAC?.RedirectData)) {
                document.write(resfac?.data?.createCheckoutFAC?.RedirectData);
                // window.location.href = output;
                return resfac?.data?.createCheckoutFAC;
              } else if (args?.code) {
                return res?.data?.createBox;
              } else {
                throw new Error("Some Error Occurred");
              }
            }
            if (
              storageService.get("currencyExchangeLocal", "local")?.provider ===
                "CAL" ||
              storageService.get("currencyExchangeLocal", "local")?.provider ===
                "CALKIDS"
            ) {
              let variables: any = {
                data: {
                  currency: args?.currency,
                  amount: args?.amount
                    ? parseFloat(args?.amount)
                    : args?.price
                    ? parseFloat(args?.price)
                    : 0,
                  payorder: res?.data?.createBox?.payOrder?.id,
                },
              };
              if (args?.code) {
                variables = {
                  ...variables,
                  discountCode: args?.code,
                };
              }
              console.log("variables", variables);
              const resCal = await client.mutate({
                mutation: REGISTER_PAYMENT,
                variables: variables,
                fetchPolicy: "no-cache",
              });

              if (is.existy(resCal?.data?.registerPayment)) {
                const paymentUrl =
                  resCal?.data?.registerPayment?.data?.session[
                    "payment-hosted-url"
                  ];
                if (paymentUrl) {
                  // Redirect to the payment URL
                  window.location.href = paymentUrl;
                  console.log(`Redirecting to: ${paymentUrl}`);
                  return {
                    ...resCal?.data?.registerPayment,
                    redirection: true,
                  };
                }
                return {
                  ...resCal?.data?.registerPayment,
                  redirection: false,
                };
              } else if (args?.code) {
                return res?.data?.createBox;
              } else {
                throw new Error("Some Error Occurred");
              }
            } else {
              let variable: any = {
                data: {
                  name: args?.name,
                  email: args?.email,
                  payOrder: res?.data?.createBox?.payOrder?.id,
                  price: args?.amount
                    ? parseFloat(args?.amount)
                    : args?.price
                    ? parseFloat(args?.price)
                    : 0,
                  currency: args?.currency,
                },
              };
              // if (args?.code) {
              //   variable = { ...variable, discountCode: args?.code }
              // }
              const orderRes = await client.mutate({
                mutation: CREATE_ORDER,
                variables: variable,
                fetchPolicy: "no-cache",
              });
              if (
                is.existy(orderRes?.data?.getAnglPayRedirectURL?.redirectUrl)
              ) {
                const output =
                  orderRes?.data?.getAnglPayRedirectURL?.redirectUrl;
                window.location.href = output;

                return orderRes?.data?.getAnglPayRedirectURL;
              } else if (
                is.existy(
                  orderRes?.data?.getAnglPayRedirectURL?.sessionId?.sessionId
                )
              ) {
                const output =
                  orderRes?.data?.getAnglPayRedirectURL?.sessionId?.sessionId;
                console.log(output);
                return {
                  redirect: "apv2",
                  sessionId: output,
                  data: {
                    price: args?.amount
                      ? parseFloat(args?.amount)
                      : args?.price
                      ? parseFloat(args?.price)
                      : 0,
                    currency: args?.currency,
                    payOrder: res?.data?.createBox?.payOrder?.id,
                  },
                };
              } else {
                throw new Error("Some Error Occurred");
              }
            }
          } else {
            return res?.data?.createBox;
          }
        } else {
          return res?.data?.createBox;
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);

      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
